export default [

    {
      path: '/ad/banner',
      meta: {
        title: '轮播图',
      },
      component: () => import('@/views/ad/banner'),
    },
    {
      path: '/ad/tab',
      meta: {
        title: '导航tab',
      },
      component: () => import('@/views/ad/tab'),
    },
    {
      path: '/ad/tile',
      meta: {
        title: '瓷片区',
      },
      component: () => import('@/views/ad/tile'),
    },
    {
      path: '/ad/king',
      meta: {
        title: '金刚区',
      },
      component: () => import('@/views/ad/king'),
    },

  ]